import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';
import { TicketExtra } from '@app/modules/model/ticketextra';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-ticket-extra',
    templateUrl:'./ui-ticket.html',
    styleUrls: [ 
        './ui-ticket.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiTicketExtra extends languageSupport implements OnInit, OnDestroy {
    @Input('ticket') _ticket: Ticket = null;
    @Input('extra') _extra: TicketExtra = null;
    @Input('refund') _refund: Boolean = false;

    private _subscriptions = [];

    /***********************************/
    /* DATA COMPONENTS                 */
    /***********************************/

    get HasRefund(){
        return (this._refund) && (this._extra.refund > 0);
    }

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._subscriptions.push(
            this.view.OnTheme.subscribe(
            data => {
                this.change.markForCheck();
            })
        );
    
        this._subscriptions.push(
            this._ticket.OnRefresh.subscribe(
            data => {
                this.change.markForCheck();
            })
        );           
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }
}
